"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBalances = void 0;
const react_query_1 = require("@tanstack/react-query");
const UltraSwapService_1 = require("src/data/UltraSwapService");
const WalletPassthroughProvider_1 = require("src/contexts/WalletPassthroughProvider");
const react_1 = require("react");
const constants_1 = require("src/constants");
const jotai_plugin_in_view_1 = require("src/stores/jotai-plugin-in-view");
const ULTRA_NATIVESOL_ID = 'SOL';
const WSOL_ID = constants_1.WRAPPED_SOL_MINT.toString();
const WRAPPED_SOL_ID = 'wSOL';
function combineSolAmounts(data) {
    const balances = structuredClone(data);
    /**
     * Note:
     * /balance return "SOL" as native sol and "So11111111111111111111111111111111111111112" as wrapped sol
     * Logic below is to convert "So11111111111111111111111111111111111111112" to wSOL and "SOL" to "So11111111111111111111111111111111111111112"
     *
     */
    if (balances[WSOL_ID]) {
        balances[WRAPPED_SOL_ID] = Object.assign({}, balances[WSOL_ID]);
    }
    if (balances[ULTRA_NATIVESOL_ID]) {
        balances[WSOL_ID] = Object.assign({}, balances[ULTRA_NATIVESOL_ID]);
    }
    return balances;
}
const useBalances = () => {
    const { publicKey } = (0, WalletPassthroughProvider_1.useWalletPassThrough)();
    const address = (0, react_1.useMemo)(() => {
        if (!publicKey)
            return '';
        return publicKey.toString();
    }, [publicKey]);
    return (0, react_query_1.useQuery)({
        queryKey: ['ultra', 'balances', address],
        queryFn: ({ signal }) => __awaiter(void 0, void 0, void 0, function* () {
            return yield UltraSwapService_1.ultraSwapService.getBalance(address, signal);
        }),
        enabled: !!address && (0, jotai_plugin_in_view_1.getPluginInView)(),
        gcTime: 20000,
        staleTime: 20000,
        refetchOnWindowFocus: false,
        refetchIntervalInBackground: false,
        refetchOnMount: false,
        select: (data) => combineSolAmounts(data),
    });
};
exports.useBalances = useBalances;
